import { ReviewerLifecycleStatus } from 'v3/Models/Enums';

export enum ReviewerProfileActionKey {
  ContinueOnboarding = 'ContinueOnboarding',
  NotReady = 'NotReady',
  Invite = 'Invite',
  Discard = 'Discard',
  Archive = 'Archive',
  Reactivate = 'Reactivate',
  Hold = 'Hold',
  RemoveHold = 'RemoveHold',
  MarkProfileCompleted = 'MarkProfileCompleted',
  EditFollowUpDate = 'EditFollowUpDate',
}

const ACTIONS_BY_STATUS: Partial<Record<ReviewerLifecycleStatus, ReviewerProfileActionKey[]>> = {
  [ReviewerLifecycleStatus.Onboarding]: [ReviewerProfileActionKey.NotReady, ReviewerProfileActionKey.Invite, ReviewerProfileActionKey.Discard],
  [ReviewerLifecycleStatus.NotReady]: [ReviewerProfileActionKey.ContinueOnboarding, ReviewerProfileActionKey.EditFollowUpDate, ReviewerProfileActionKey.Invite, ReviewerProfileActionKey.Discard],
  [ReviewerLifecycleStatus.Invited]: [ReviewerProfileActionKey.Discard, ReviewerProfileActionKey.Hold, ReviewerProfileActionKey.RemoveHold],
  [ReviewerLifecycleStatus.Active]: [ReviewerProfileActionKey.Archive, ReviewerProfileActionKey.Hold, ReviewerProfileActionKey.RemoveHold, ReviewerProfileActionKey.MarkProfileCompleted],
  [ReviewerLifecycleStatus.Archived]: [ReviewerProfileActionKey.Reactivate],
};

export const isReviewerActionAvailable = (
  action: ReviewerProfileActionKey,
  statusValue?: number
): boolean => (ACTIONS_BY_STATUS[statusValue as ReviewerLifecycleStatus] ?? []).includes(action);
